import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { fetchGalleryData } from "../../redux/slicer/homeSlicer";

function ImageAlbumGrid() {
  const dispatch = useDispatch();
  const {
    data: galleryDataFromRedux,
    loading,
    error,
  } = useSelector((state) => state.home.gallery);

  const galleryData = galleryDataFromRedux;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAlbum, setSelectedAlbum] = useState(null);

  const CustomPrevArrow = (props) => {
    const { onClick } = props;
    return (
      <div
        onClick={onClick}
        className="absolute top-1/2 -left-4 transform -translate-y-1/2 z-10 hidden group-hover:block cursor-pointer bg-white p-2 rounded-full shadow-lg"
      >
        <FaChevronLeft size={20} alt="Previous" />
      </div>
    );
  };

  const CustomNextArrow = (props) => {
    const { onClick } = props;
    return (
      <div
        onClick={onClick}
        className="absolute top-1/2 -right-4 transform -translate-y-1/2 z-10 hidden group-hover:block cursor-pointer bg-white p-2 rounded-full shadow-lg"
      >
        <FaChevronRight size={20} alt="Next" />
      </div>
    );
  };

  useEffect(() => {
    dispatch(fetchGalleryData());
  }, [dispatch]);

  const openModal = (album) => {
    setSelectedAlbum(album);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedAlbum(null);
  };

  const sliderSettings = {
    dots: true,
    infinite: selectedAlbum?.images.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  if (!galleryData?.length) return <div>No albums available</div>;

  const mergedGalleryData = [...galleryData];

  // Capture the name *before* splicing
  let combinedAlbumName = "SAB Event"; // Default, in case something goes wrong
  if (galleryData.length >= 8) {
    const album8thIndexImage = mergedGalleryData[7];
    combinedAlbumName = mergedGalleryData[7].album_name; // Capture the name from initial data

    mergedGalleryData.splice(7, 1);

    mergedGalleryData.splice(7, 0, {
      album_id: 'space-combined',
      album_name: combinedAlbumName, // Use captured name
      images: [album8thIndexImage.images[0]],
    });
  }

  const displayCombinedImage = mergedGalleryData[7]?.images[0]?.image_url;
  const combinedAlbum = mergedGalleryData[7]; // Get the combined album data

  return (
    <div className="container mx-auto p-6">
      <h2 className="text-3xl font-bold text-center mb-8 text-primary-color font-titillium">
        Gallery
      </h2>
      {/* Masonry Grid Layout */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 py-10 md:py-20">
        {mergedGalleryData.slice(0, 8).map((album, index) => {
          if (album.album_id === 'space-combined' && combinedAlbum) {
            return (
              <div
                key={album.album_id}
                className={`relative overflow-hidden rounded-lg shadow-md group cursor-pointer lg:col-span-2`}
                onClick={() => openModal(album)}
              >
                <img
                  src={displayCombinedImage}
                  alt={album.album_name}
                  className="w-full h-[200px] object-cover transition-transform duration-300 group-hover:scale-105"
                  style={{ height: '300px', objectFit: 'cover' }}
                />
                <div className="absolute inset-0 bg-black bg-opacity-50 flex items-end transition-opacity duration-300">
                  <div className="p-4 text-white">
                    <h3 className="text-lg font-semibold">{combinedAlbum.album_name}</h3>{/*Using correct album name*/}
                    <span className="block w-10 h-1 bg-purple-500 mt-2"></span>
                  </div>
                </div>
              </div>
            );
          }

          return (
            <div
              key={album.album_id}
              className={`relative overflow-hidden rounded-lg shadow-md group cursor-pointer ${index % 3 === 0 ? "row-span-2" : ""}`}
              onClick={() => openModal(album)}
            >
              <img
                src={album.images[0]?.image_url}
                alt={album.album_name}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black bg-opacity-50 flex items-end transition-opacity duration-300">
                <div className="p-4 text-white">
                  <h3 className="text-lg font-semibold">{album.album_name}</h3>
                  <span className="block w-10 h-1 bg-purple-500 mt-2"></span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {/* Popup Modal with Slider */}
      {isModalOpen && selectedAlbum && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-80 z-50">
          <div className="relative max-w-5xl w-full mx-4 sm:mx-8  rounded-lg shadow-lg overflow-hidden">
            {/* Close Button */}
            <button
              className="absolute top-1 right-2 text-red-600 text-3xl sm:text-4xl hover:text-red-600 z-50"
              onClick={closeModal}
            >
              <IoIosCloseCircleOutline alt="Close Modal" />
            </button>
            {/* Image Slider */}
            <div className="relative group px-5">
              <Slider {...sliderSettings}>
                {selectedAlbum.images.map((image) => (
                  <div
                    key={image.image_id}
                    className="flex justify-center items-center px-4 sm:px-8"
                  >
                    <img
                      src={image.image_url}
                      alt={`Image ${image.image_id}`}
                      className="w-full h-[300px] sm:h-[400px] md:h-[500px] object-contain rounded-lg"
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ImageAlbumGrid;